<template>
  <div class="container">
    <div class="search-box">
      <el-input
        v-model="getselCon"
        placeholder="請問有甚麼可以幫到你？"
        class="w120"
        @blur="changeShowHot"
        @focus="getHot"
        @keyup.enter.native="searchQue(1)"
      />
      <div
        v-if="showHot && hotquestions.length > 0"
        class="search-box-hot"
      >
        <div
          v-if="hotquestions"
          class="hot-ques"
        >
          熱門問題
        </div>
        <div
          v-for="(item, index) in hotquestions"
          :key="index"
          class="hot-for-ques"
          @click="toMainBody(item, titleNameWithCulture, 'hot')"
        >
          {{ item.titleNameWithCulture }}
        </div>
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchQue(1, 'search')"
      >
        搜尋
      </el-button>
    </div>
    <div
      v-if="getselCon"
      class="search-con-box"
    >
      <div class="search-count-box">
        <span class="search-count-one">{{ getselCon }}</span>
        <span v-if="count != -1">的搜尋結果：{{ count }} 項</span>
      </div>
      <template v-if="searchquestions && searchquestions.length > 0">
        <div
          v-for="(item, index) in searchquestions"
          :key="index"
          class="search-for-box"
        >
          <div
            class="search-for-tit"
            @click="toMainBody(item, item.titleNameText, 'title')"
            v-html="item.titleNameText"
          />
          <div class="search-for-mid">
            <span
              v-if="item.categoryResponse"
              @click="goAsideList(item.categoryID)"
            >{{ item.categoryResponse.categoryNameWithCulture }}</span>
            <span v-if="item.subCategoryResponse">&nbsp;>&nbsp;</span>
            <span
              v-if="item.subCategoryResponse"
              @click="goAsideList(item.subCategoryID)"
            >{{ item.subCategoryResponse.categoryNameWithCulture }}</span>
          </div>
          <div
            class="search-for-bottom"
            @click="toMainBody(item, item.matchContentText, 'content')"
            v-html="item.matchContentText"
          />
        </div>
      </template>
      <template v-if="count == 0">
        <div class="search-null-box">
          暫時找不到符合您搜索條件的內容
        </div>
      </template>
      <!-- <el-button @click="current" type="primary" icon="el-icon-search">页数+1</el-button> -->
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="20"
        layout="prev, pager, next, jumper"
        :total="count"
        hide-on-single-page
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            showHot: false,
            hotquestions: [],
            searchquestions: [],
            count: -1,
            currentPage: 1
        };
    },
    //* 可退回瀏覽歷史
    // watch: {
    //     $route(to, from) {
    //         if (to.query.selcon != from.query.selcon) {
    //             this.$store.commit('changesearchRes', to.query.selcon);
    //             this.searchQue('1');
    //         }
    //     }
    // },
    computed: {
        getselCon: {
            get() {
                return this.$store.state.searchRes;
            },
            set(newVal) {
                this.$store.commit('changesearchRes', newVal);
            }
        }
    },
    created() {
        if (this.$store.state.searchBox) {
            this.$store.commit('changesearchRes', this.$store.state.searchBox);
        }
        //* 可退回瀏覽歷史
        // if (this.$route.query.selcon) {
        //     this.$store.commit('changesearchRes', this.$route.query.selcon);
        // }
        this.$store.commit('changesearchBox', '');
        this.searchQue('1','search');
        window.addEventListener('scroll', this.handleScroll, true);
        gio('track', 'enter_in', {
            channel: '幫助中心',
            page: '幫助中心文章搜索結果列表頁',
            platform: 'web'
        });
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    },
    methods: {
        changeShowHot() {
            setTimeout(() => {
                this.showHot = false;
            }, 500);
        },
        handleScroll() {
            this.showHot = false;
        },
        current() {
            this.currentPage++;
        },
        handleCurrentChange(val) {
            this.searchQue(val);
        },
        goAsideList(categoryID) {
            this.$router.push({ path: '/helpcenter/asidelist', query: { categoryID: categoryID } });
        },
        toMainBody(item, titleNameWithCulture, type) {
            this.$store.commit('changefrompage', '幫助中心文章搜索結果列表頁');
            if (type == 'hot') {
                gio('track', 'search_match', {
                    channel: '幫助中心',
                    location: '幫助中心文章搜索結果列表頁_搜索框',
                    match_keywords_click: titleNameWithCulture,
                    match_result_num: this.hotquestions.length,
                    match_type: '幫助中心',
                    page: '幫助中心文章搜索結果列表頁',
                    platform: 'web'
                });
                gio('evar.set', {
                    evar_ad_position: `幫助中心文章搜索結果列表頁${titleNameWithCulture}`,
                    evar_page: '幫助中心文章搜索結果列表頁'
                });
            } else {
                gio('track', 'element_click', {
                    channel: '幫助中心',
                    location: `幫助中心文章搜索結果列表_${item.titleNameWithCulture}`,
                    element_name: item.titleNameWithCulture,
                    element_link: `/helpcenter/mainbody?questionId=${item.id}`,
                    element_content: item.contentFilterHTMLWithCulture,
                    page: '幫助中心文章搜索結果列表頁',
                    platform: 'web'
                });
                if (type == 'title') {
                    gio('evar.set', {
                        evar_ad_position: `幫助中心文章搜索結果列表頁_${item.titleNameWithCulture}`,
                        evar_page: '幫助中心文章搜索結果列表頁'
                    });
                }
            }
            this.$router.push({ path: '/helpcenter/mainbody', query: { questionId: item.id } });
            let arr = [];
            if (JSON.parse(localStorage.getItem('questionId'))) {
                arr = JSON.parse(localStorage.getItem('questionId'));
            } else {
                arr = [];
            }
            arr = [...new Set(arr)];
            arr.unshift(item.id);
            if (arr.length > 5) {
                arr.pop();
            }
            localStorage.setItem('questionId', JSON.stringify(arr));
            // this.$router.push({ name: this.pub.routeNameLists.MainBody, params: { questionId: item.id } });
        },
        getHot() {
            this.axios.get(this.pub.getApi().GetHotQuestions, { params: { count: 5 } }).then(res => {
                if (res.data.code === 0 && res.data.result) {
                    this.hotquestions = res.data.result;
                }
            });
            this.showHot = true;
        },
        searchQue(val, searchType) {
            this.showHot = false;
            if (!this.getselCon.trim()) {return;}
            // * 可退回瀏覽歷史
            // this.$router.push({ name: this.pub.routeNameLists.HelpSearchResult, query: { selcon: this.$store.state.searchRes } });

            this.axios
                .post(this.pub.getApi().SearchQuestions, {
                    keywords: this.$store.state.searchRes,
                    order: 'default',
                    pageIndex: val,
                    pageCount: 20
                })
                .then(res => {
                    if (res.data.code === 0 && res.data.result) {
                        this.count = res.data.result.count;
                        this.searchquestions = res.data.result.data;
                        this.searchquestions.forEach((v, i) => {
                            v.matchContentText = v.matchContentWithCulture;
                            v.titleNameText = v.titleNameWithCulture;
                            let inHigh = '<span style="color:#ED1C24;">' + this.$store.state.searchRes + '</span>';
                            v.matchContentText = v.matchContentText.replace(this.$store.state.searchRes, inHigh);
                            v.titleNameText = v.titleNameText.replace(this.$store.state.searchRes, inHigh);
                        });
                    }
                    if (searchType == 'search') {
                        gio('track', 'search_click', {
                            channel: '幫助中心',
                            location: `幫助中心文章搜索結果列表_搜索結果`,
                            page: '幫助中心文章搜索結果列表頁',
                            platform: 'web',
                            search_from: '幫助中心首頁',
                            search_keywords: this.$store.state.searchRes,
                            search_result_num: this.count,
                            search_type: '幫助中心'
                        });
                    }
                });
        }
    }
};
</script>

<style scoped lang="less">
.container {
    padding-left: 20px;
    padding-right: 20px;
    background-color: #f3f3f5;
    .search-box {
        text-align: left;
        .w120 {
            width: 45%;
            height: 46px;
            margin-right: 15px;
        }
        /deep/.el-input__inner {
            border-radius: 11px;
            height: 46px;
            &::placeholder {
                color: #999999;
            }
            &::-webkit-input-placeholder {
                color: #999999;
            }
            &:-moz-placeholder {
                color: #999999;
                opacity: 1;
            }
            &::-moz-placeholder {
                color: #999999;
                opacity: 1;
            }
            &:-ms-input-placeholder {
                color: #999999;
            }
        }
        .hot-ques {
            color: #444444;
            font-size: 14px;
            height: 44px;
            line-height: 44px;
            border-bottom: 1px solid #eeeeee;
        }
        .hot-for-ques {
            color: #444444;
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            cursor: pointer;
        }
        .search-box-hot {
            width: 45%;
            padding: 0 12px;
            position: absolute;
            z-index: 1;
            top: 125px;
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 3px 4px 3px #efefef;
        }
    }
    .search-con-box {
        background-color: #fff;
        text-align: left;
        margin-top: 30px;
        border-radius: 15px;
        padding: 30px;
        /deep/ .el-pagination {
            margin-top: 30px;
            text-align: right;
        }
        .search-count-box {
            height: 53px;
            border-bottom: 1px solid #eeeeee;
            font-size: 24px;
            color: #333333;
            font-weight: 700;
            .search-count-one {
                color: #e70e1a;
            }
        }
        .search-null-box {
            color: #333;
            font-size: 18px;
            margin-top: 30px;
            height: 300px;
        }
        .search-for-box {
            margin-top: 30px;
            border-bottom: 1px solid #eeeeee;
            padding-bottom: 20px;
            .search-for-tit {
                font-size: 18px;
                color: #333333;
                font-weight: 700;
            }
            .search-for-tit:hover {
                text-decoration: underline;
                cursor: pointer;
            }
            .search-for-mid {
                margin-top: 10px;
                margin-bottom: 12px;
                color: #999999;
                font-size: 14px;
                span:hover {
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
            .search-for-bottom {
                font-size: 16px;
                color: #333333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                cursor: pointer;
            }
            .search-for-bottom:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
